import { render, staticRenderFns } from "./technology.vue?vue&type=template&id=5b8d89ba&"
import script from "./technology.vue?vue&type=script&lang=js&"
export * from "./technology.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports